import React, { useEffect, useState } from "react";
import { AccordionNav } from "@services/ui-components";
import { Accordion } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { AccordionEventKey } from "react-bootstrap/AccordionContext";
import { getSidebarAccess } from "@me-team/common/src/services/SidebarService/sidebarAccess";

type accordionItemProps = {
    label: string;
    to: string;
    href?: string;
    active: boolean;
};

type accordionDataProps = {
    title: string;
    items: accordionItemProps[];
    icon?: string;
    active: boolean;
    inactiveLink?: string;
    iconPath?: string | React.ComponentType<React.SVGProps<SVGSVGElement>>;
};

type SidebarMenuProps = {
    accordionsData: accordionDataProps[];
    handleCloseNavbar?: () => void;
    isRegistrationOrCreateOwner?: boolean;
};

const SidebarMenu: React.FC<SidebarMenuProps> = (props: SidebarMenuProps) => {
    const { accordionsData, isRegistrationOrCreateOwner } = props;
    const location = useLocation();
    const [activeKey, setActiveKey] = useState<number | AccordionEventKey>(-1);
    const { canAccessTariffModulesManageRoot } = getSidebarAccess();

    const filteredItems = (accordion: accordionDataProps) => accordion.items.filter(Boolean);

    const currentActiveKey = accordionsData.findIndex((data) => {
        return filteredItems(data).some((item: accordionItemProps) => {
            const pathSegments = item.to.split("/");
            const filteredPath = pathSegments.slice(0, -1).join("/");
            const startPath = pathSegments[0];
            if (location.pathname.startsWith("/products/write-off")) {
                return item.to.includes("logbook/journal");
            }
            if (location.pathname.startsWith(`/services-providers`)) {
                return location.pathname.startsWith(`/${startPath}`);
            }
            if (location.pathname.startsWith(`/warehouses`) || location.pathname.startsWith(`/warehouse`)) {
                return location.pathname.startsWith(`/${startPath}`);
            }
            if (location.pathname.startsWith(`/payment/company`)) {
                return location.pathname.startsWith(`/${startPath}`);
            }
            if (location.pathname.startsWith(`/logbook`)) {
                return location.pathname.startsWith(`/${startPath}`);
            }
            if (
                location.pathname.startsWith(`/menu/all-menus`) ||
                location.pathname.startsWith(`/menu/page`) ||
                /^\/menu\/[^/]+\/(preview|before-publish)/.test(location.pathname)
            ) {
                return location.pathname.startsWith(`/${startPath}`);
            }
            if (location.pathname.startsWith(`/menu/dishes`) || location.pathname.startsWith(`/menu/update-dish`)) {
                return item.to.includes("menu/dishes");
            }
            return `/${item.to}` === filteredPath || location.pathname.startsWith(`/${filteredPath}`);
        });
    });

    useEffect(() => {
        setActiveKey(currentActiveKey);
    }, [currentActiveKey]);

    return (
        <Accordion
            activeKey={`${activeKey}`}
            onSelect={(k) => setActiveKey(k)}
            className={`pb-3 ${isRegistrationOrCreateOwner ? "pe-none opacity-25" : ""} accordion-sidebar`}
        >
            {accordionsData.map((accordion, index) => {
                const visibleItems = filteredItems(accordion);

                return (
                    <AccordionNav
                        key={index}
                        title={accordion.title}
                        items={visibleItems}
                        firstItemLink={visibleItems[0]?.to}
                        active={accordion.active}
                        icon={accordion.icon}
                        eventKey={index.toString()}
                        handleCloseNavbar={props.handleCloseNavbar}
                        inactiveLink={accordion.inactiveLink}
                        iconPath={accordion.iconPath}
                        canShowInactiveLink={canAccessTariffModulesManageRoot}
                    />
                );
            })}
        </Accordion>
    );
};

export default SidebarMenu;
